export class ZefGitlabState {
  repositories: ZefGitlabRepository[];
  authorized: boolean;
  branchMap: Record<string, Array<ZefGitlabBranch>>;
}

export enum ZefGitlabAuthUrlType {
  Registration = 'REGISTRATION',
  Login = 'LOGIN',
  Repository = 'REPOSITORY'
}

export interface ZefGitlabConfig {
  callbackUrl?: string;
  apiUrl?: string;
}

export interface ZefGitlabRepository {
  fullName: string;
  name: string;
  owner: string;
  ownerUrl: string;
  private: boolean;
}

export interface ZefGitlabBranch {
  name: string;
  isDefault: boolean;
}

export interface ZefGitlabAuthUrlResponse {
  gitlabUrl: string;
}

export interface ZefGitlabApiAuthorizePayload {
  state: string;
  code: string;
  // Only meaningful on the signup call: a promo code carried through the OAuth
  // round-trip from a deep link.
  promoCode?: string;
  // Likewise the ZCP-pool claim. The backend takes it on this body, the same
  // way the native registration sends it.
  claimZcpPool?: boolean;
}

export interface ZefGitlabAuthStateData {
  action: ZefGitlabAuthUrlType;
  key: string;
  nonHaRecipe?: string;
  haRecipe?: string;
  /** See `ZefGithubAuthStateData.z3` — the Zerops Code hand-over. */
  z3?: string;
}
